import pdfPackage from 'pdfjs-dist/package.json';
import workerUrl from 'pdfjs-dist/legacy/build/pdf.worker.min.mjs?url';
import assetBase from 'virtual:mediagraph-pdf-assets';

export const PDFJS_VERSION = pdfPackage.version;
export const PDFJS_WORKER_URL = workerUrl;
export const PDFJS_IMAGE_RESOURCES_PATH = `${assetBase}web/images/`;

export const transformPdfDocumentParams = params => ({
    ...params,
    cMapUrl: `${assetBase}cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${assetBase}standard_fonts/`,
    wasmUrl: `${assetBase}wasm/`,
    iccUrl: `${assetBase}iccs/`,
    // Retain the explicit policy for compatibility. PDF.js 6 removed eval itself;
    // this option is no longer the mitigation. PDF scripting is never enabled.
    isEvalSupported: false,
});

let library;
export function loadPdfLibrary() {
    return library ||= (async () => {
        // The component bundle consumes globalThis.pdfjsLib populated by core.
        const core = await import('pdfjs-dist/legacy/build/pdf.mjs');
        core.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_URL;
        const viewer = await import('pdfjs-dist/legacy/web/pdf_viewer.mjs');
        if (!document.querySelector('[data-mediagraph-pdf-l10n]')) {
            const link = document.createElement('link');
            link.type = 'application/l10n';
            link.dataset.mediagraphPdfL10n = 'true';
            link.href = `${assetBase}locale/locale.json`;
            document.head.prepend(link);
        }
        return {...core, ...viewer};
    })();
}
